import type { VatFeeProfile } from "../app-main/selectors/fee-profile.selectors";
import { baseApi } from "../app-main/store/baseApi";

export type GetVatFeeProfilesArgs = {
  ssoId: string;
};

/**
 * A host's VAT fee profiles. Same endpoint the payments pages read through the
 * legacy `fee_profiles` thunks, which the Host Hub never populates.
 */
export const feesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVatFeeProfiles: builder.query<VatFeeProfile[], GetVatFeeProfilesArgs>({
      query: ({ ssoId }) => ({
        url: `/v1/fees/profiles/${ssoId}/VAT`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetVatFeeProfilesQuery } = feesApi;
